module.exports = {
        srcSet: __webpack_public_path__ + "4c51ed7d80f7a97e-600.webp"+" 600w"+","+__webpack_public_path__ + "55f591fde1621391-1000.webp"+" 1000w",
        images: [{path: __webpack_public_path__ + "4c51ed7d80f7a97e-600.webp",width: 600,height: 300},{path: __webpack_public_path__ + "55f591fde1621391-1000.webp",width: 1000,height: 500}],
        src: __webpack_public_path__ + "55f591fde1621391-1000.webp",
        toString: function(){return __webpack_public_path__ + "55f591fde1621391-1000.webp"},
        
        width: 1000,
        height: 500
      }